import type { UseEmblaCarouselType } from "embla-carousel-react";
import { useEffect } from "react";

/**
 * 用于解决移动端 Safari 从 bfcache返回页面时 embla-carousel-autoplay 插件停止工作的问题。
 *
 * @param emblaApi - 从 useEmblaCarousel 返回的 API 实例。
 */
export const useAutoplayOnBfcache = (
  emblaApi: UseEmblaCarouselType[1] | undefined,
) => {
  useEffect(() => {
    if (!emblaApi) return;

    const handlePageshow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        console.log("Page restored from bfcache. Restarting autoplay...");

        const autoplay = emblaApi.plugins().autoplay;

        autoplay.play();
      }
    };

    window.addEventListener("pageshow", handlePageshow);

    return () => {
      window.removeEventListener("pageshow", handlePageshow);
    };
  }, [emblaApi]);
};
